var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBackWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "9px",
    height: "18px",
    viewBox: "0 0 9 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icBackWhite") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.6257026,60.7281675 C13.6460628,60.7468051 13.6655902,60.7663325 13.6842278,60.7866927 L20.6015767,68.3433858 C20.8138539,68.575283 20.9110378,68.8742654 20.8931286,69.167588 C20.9112476,69.4609859 20.8140831,69.7603638 20.6015767,69.9925114 L13.6842278,77.5492046 C13.3345157,77.9312392 12.7413178,77.9574418 12.3592831,77.6077297 C12.338923,77.5890921 12.3193956,77.5695647 12.300758,77.5492046 C11.9092353,77.121495 11.9092353,76.4655755 12.300758,76.0378659 L18.589116,69.1671058 L12.300758,62.2980313 C11.9092353,61.8703217 11.9092353,61.2144023 12.300758,60.7866927 C12.6504701,60.4046581 13.243668,60.3784554 13.6257026,60.7281675 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main-screens-Stage-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Active-now",
    transform: "translate(-12.000000, -60.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icBackWhite",
    fill: "#D8D8D8",
    fillRule: "nonzero",
    transform: "translate(16.451167, 69.167949) rotate(180.000000) translate(-16.451167, -69.167949) ",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackWhite);
export default __webpack_public_path__ + "static/media/icBackWhite.dfdcdb6e15b8d137cd0a8eebfc95104e.svg";
export { ForwardRef as ReactComponent };